/* eslint-disable
    func-names,
    no-sequences,
    no-unused-expressions,
    no-unused-vars,
    one-var,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS201: Simplify complex destructure assignments
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['$stateParams', 'LedgerCollection'];

const AccountSelectCtrl = function ($stateParams, LedgerCollection) {
  let adjustedLength, array, day;
  this.$stateParams = $stateParams;
  (array = $stateParams.date.split('-')),
    (adjustedLength = Math.max(array.length, 1)),
    ([this.month, day] = Array.from(array.slice(0, adjustedLength - 1))),
    (this.year = array[adjustedLength - 1]);

  const ledgers = new LedgerCollection($stateParams.clientId);

  this.accounts = ledgers
    .$filter(
      ledger =>
        ledger.role === 'BANK_ACCOUNT' ||
        ledger.role === 'STATEMENT_PROCESSING_ACCOUNT' ||
        ledger.role === 'CREDIT_CARD' ||
        ledger.role === 'EQUITY_ACCOUNT',
    )
    .$listen(ledgers);
};

AccountSelectCtrl.$inject = deps;

module.exports = AccountSelectCtrl;
